export default [
    {
        path: '/main',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {
          title: '财务中台'
        },
        children:[
          {
            path: '/',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '财务中台-控制台',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'console',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '财务中台-控制台',
              keepAlive: true // 需要缓存
            },
          },
          

          {
            path: 'carInsuranceCaseManage',
            name: 'carInsuranceCaseManage',
            component: () => import('@/views/main/carInsurance/caseManage'),
            meta: {
              title: '财务中台-车险公估-案件管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'carInsuranceFinanceManage',
            name: 'carInsuranceFinanceManage',
            component: () => import('@/views/main/carInsurance/financeManage'),
            meta: {
              title: '财务中台-车险公估-财务管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'carInsuranceSettlementProject',
            name: 'carInsuranceSettlementProject',
            component: () => import('@/views/main/carInsurance/settlementProject'),
            meta: {
              title: '财务中台-车险公估-结算立项',
              keepAlive: true // 需要缓存
            },
          },

          {
            path: 'carInsuranceSettlementProjectDetail',
            name: 'carInsuranceSettlementProjectDetail',
            component: () => import('@/views/main/carInsurance/settlementProjectDetail'),
            meta: {
              title: '财务中台-车险公估-结算立项'
            },
          },


          {
            path: 'medicalInsuranceCaseManage',
            name: 'medicalInsuranceCaseManage',
            component: () => import('@/views/main/medicalInsurance/caseManage'),
            meta: {
              title: '财务中台-意健险-案件管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'medicalInsuranceFinanceManage',
            name: 'medicalInsuranceFinanceManage',
            component: () => import('@/views/main/medicalInsurance/financeManage'),
            meta: {
              title: '财务中台-意健险-财务管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'medicalInsuranceSettlementProject',
            name: 'medicalInsuranceSettlementProject',
            component: () => import('@/views/main/medicalInsurance/settlementProject'),
            meta: {
              title: '财务中台-意健险-结算立项',
              keepAlive: true // 需要缓存
            },
          },


          {
            path: 'assetsAppraisalCaseManage',
            name: 'assetsAppraisalCaseManage',
            component: () => import('@/views/main/assetsAppraisal/caseManage'),
            meta: {
              title: '财务中台-资产评估-案件管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'assetsAppraisalFinanceManage',
            name: 'assetsAppraisalFinanceManage',
            component: () => import('@/views/main/assetsAppraisal/financeManage'),
            meta: {
              title: '财务中台-资产评估-财务管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'assetsAppraisalSettlementProject',
            name: 'assetsAppraisalSettlementProject',
            component: () => import('@/views/main/assetsAppraisal/settlementProject'),
            meta: {
              title: '财务中台-资产评估-结算立项',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'assetsAppraisalSettlementProjectDetail',
            name: 'assetsAppraisalSettlementProjectDetail',
            component: () => import('@/views/main/assetsAppraisal/settlementProjectDetail'),
            meta: {
              title: '财务中台-资产评估-结算立项'
            },
          },


          {
            path: 'compensateCaseManage',
            name: 'compensateCaseManage',
            component: () => import('@/views/main/compensate/caseManage'),
            meta: {
              title: '财务中台-资产评估-案件管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'compensateFinanceManage',
            name: 'compensateFinanceManage',
            component: () => import('@/views/main/compensate/financeManage'),
            meta: {
              title: '财务中台-资产评估-财务管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'compensateSettlementProject',
            name: 'compensateSettlementProject',
            component: () => import('@/views/main/compensate/settlementProject'),
            meta: {
              title: '财务中台-资产评估-结算立项',
              keepAlive: true // 需要缓存
            },
          },

          {
            path: 'claimsCaseManage',
            name: 'claimsCaseManage',
            component: () => import('@/views/main/claims/claimsCaseManage'),
            meta: {
              title: '财务中台-意健险理赔-案件管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'claimsFinanceManage',
            name: 'claimsFinanceManage',
            component: () => import('@/views/main/claims/claimsFinanceManage'),
            meta: {
              title: '财务中台-意健险理赔-财务管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'claimsSettlementProject',
            name: 'claimsSettlementProject',
            component: () => import('@/views/main/claims/claimsSettlementProject'),
            meta: {
              title: '财务中台-意健险理赔-结算立项',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'role',
            name: 'role',
            component: () => import('@/views/main/role/index'),
            meta: {
              title: '财务中台-角色管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'account',
            name: 'account',
            component: () => import('@/views/main/account/index'),
            meta: {
              title: '财务中台-账号管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'password',
            name: 'password',
            component: () => import('@/views/main/account/password'),
            meta: {
              title: '财务中台-密码修改',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'statistics',
            name: 'statistics',
            component: () => import('@/views/main/statistics/index'),
            meta: {
              title: '财务中台-统计管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'statisticsClearing',
            name: 'statisticsClearing',
            component: () => import('@/views/main/statistics/clearing'),
            meta: {
              title: '财务中台-统计管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'invoiceEntry',
            name: 'invoiceEntry',
            component: () => import('@/views/main/invoiceEntry/index'),
            meta: {
              title: '财务中台-发票录入',
              keepAlive: true // 需要缓存
            },
          },

          {
            path: 'company',
            name: 'company',
            component: () => import('@/views/main/companyManage/company'),
            meta: {
              title: '财务中台-公司管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'department',
            name: 'department',
            component: () => import('@/views/main/companyManage/department'),
            meta: {
              title: '财务中台-部门管理',
              keepAlive: true // 需要缓存
            },
          },

          {
            path: 'statisticsAssetsAppraisal',
            name: 'statisticsAssetsAppraisal',
            component: () => import('@/views/main/assetsAppraisal/statistics'),
            meta: {
              title: '财务中台-统计数据',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'statisticsCarInsurance',
            name: 'statisticsCarInsurance',
            component: () => import('@/views/main/carInsurance/statistics'),
            meta: {
              title: '财务中台-统计数据',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'statisticsCompensate',
            name: 'statisticsCompensate',
            component: () => import('@/views/main/compensate/statistics'),
            meta: {
              title: '财务中台-统计数据',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'statisticsMedicalInsurance',
            name: 'statisticsMedicalInsurance',
            component: () => import('@/views/main/medicalInsurance/statistics'),
            meta: {
              title: '财务中台-统计数据',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'statisticsClaims',
            name: 'statisticsClaims',
            component: () => import('@/views/main/claims/statistics'),
            meta: {
              title: '财务中台-统计数据',
              keepAlive: true // 需要缓存
            },
          },




          {
            path: 'carOutsuranceCaseManage',
            name: 'carOutsuranceCaseManage',
            component: () => import('@/views/main/carOutsource/caseManage'),
            meta: {
              title: '财务中台-案件管理(外包)',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'carOutsuranceFinanceManage',
            name: 'carOutsuranceFinanceManage',
            component: () => import('@/views/main/carOutsource/financeManage'),
            meta: {
              title: '财务中台-财务管理(外包)',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'carOutsuranceSettlementProject',
            name: 'carOutsuranceSettlementProject',
            component: () => import('@/views/main/carOutsource/settlementProject'),
            meta: {
              title: '财务中台-结算立项(外包)',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'statisticsCarOutsurance',
            name: 'statisticsCarOutsurance',
            component: () => import('@/views/main/carOutsource/statistics'),
            meta: {
              title: '财务中台-统计数据(外包)',
              keepAlive: true // 需要缓存
            },
          },


          {
            path: 'assetsOutAppraisalCaseManage',
            name: 'assetsOutAppraisalCaseManage',
            component: () => import('@/views/main/assetsOutAppraisal/caseManage'),
            meta: {
              title: '财务中台-案件管理(外包)',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'assetsOutAppraisalFinanceManage',
            name: 'assetsOutAppraisalFinanceManage',
            component: () => import('@/views/main/assetsOutAppraisal/financeManage'),
            meta: {
              title: '财务中台-财务管理(外包)',
              // keepAlive: true // 需要缓存
            },
          },
          {
            path: 'assetsOutAppraisalSettlementProject',
            name: 'assetsOutAppraisalSettlementProject',
            component: () => import('@/views/main/assetsOutAppraisal/settlementProject'),
            meta: {
              title: '财务中台-结算立项(外包)',
              // keepAlive: true // 需要缓存
            },
            
          },
          {
            path: 'assetsOutAppraisalSettlementProjectDetail',
            name: 'assetsOutAppraisalSettlementProjectDetail',
            component: () => import('@/views/main/assetsOutAppraisal/settlementProjectDetail'),
            meta: {
              title: '财务中台-结算立项(外包)',
            },
            
          },
          
          // {
          //   path: 'statisticsassetsOutAppraisal',
          //   name: 'statisticsassetsOutAppraisal',
          //   component: () => import('@/views/main/assetsOutAppraisal/statistics'),
          //   meta: {
          //     title: '财务中台-统计数据(外包)',
          //     keepAlive: true // 需要缓存
          //   },
          // },



          {
            path: 'accidentRiskCaseManage',
            name: 'accidentRiskCaseManage',
            component: () => import('@/views/main/accidentRisk/caseManage'),
            meta: {
              title: '财务中台-意健险-案件管理',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'accidentRiskFinanceManage',
            name: 'accidentRiskFinanceManage',
            component: () => import('@/views/main/accidentRisk/financeManage'),
            meta: {
              title: '财务中台-意健险-财务管理',
              keepAlive: true // 需要缓存
            },
          },





          

          {
            path: 'accidentRiskSettlementProject',
            name: 'accidentRiskSettlementProject',
            component: () => import('@/views/main/accidentRisk/settlementProject'),
            meta: {
              title: '财务中台-意健险-结算立项',
              keepAlive: true // 需要缓存
            },
          },

          {
            path: 'accidentRiskSettlementProjectDetail',
            name: 'accidentRiskSettlementProjectDetail',
            component: () => import('@/views/main/accidentRisk/settlementProjectDetail'),
            meta: {
              title: '财务中台-意健险-结算立项'
            },
          },
          {
            path: 'accidentRiskStatistics',
            name: 'accidentRiskStatistics',
            component: () => import('@/views/main/accidentRisk/statistics'),
            meta: {
              title: '财务中台-统计数据(外包)',
              keepAlive: true // 需要缓存
            },
          },
          {
            path: 'carInsuranceSettlementProjectDetail',
            name: 'carInsuranceSettlementProjectDetail',
            component: () => import('@/views/main/carInsurance/settlementProjectDetail'),
            meta: {
              title: '财务中台-意健险-结算立项'
            },
          },

          {
            path: 'carOutsourceSettlementProjectDetail',
            name: 'carOutsourceSettlementProjectDetail',
            component: () => import('@/views/main/carOutsource/settlementProjectDetail'),
            meta: {
              title: '财务中台-意健险-结算立项'
            },
          },


          {
            path: 'assetsAppraisalSettlementProjectDetail',
            name: 'assetsAppraisalSettlementProjectDetail',
            component: () => import('@/views/main/assetsAppraisal/settlementProjectDetail'),
            meta: {
              title: '财务中台-意健险-结算立项'
            },
          },

          {
            path: 'claimsSettlementProjectDetail',
            name: 'claimsSettlementProjectDetail',
            component: () => import('@/views/main/claims/claimsSettlementProjectDetail'),
            meta: {
              title: '财务中台-意健险-结算立项'
            },
          },

          {
            path: 'compensateSettlementProjectDetail',
            name: 'compensateSettlementProjectDetail',
            component: () => import('@/views/main/compensate/settlementProjectDetail'),
            meta: {
              title: '财务中台-意健险-结算立项'
            },
          },

          {
            path: 'medicalInsuranceSettlementProjectDetail',
            name: 'medicalInsuranceSettlementProjectDetail',
            component: () => import('@/views/main/medicalInsurance/settlementProjectDetail'),
            meta: {
              title: '财务中台-意健险-结算立项'
            },
          },

          {
            path: 'oerationLog',
            name: 'oerationLog',
            component: () => import('@/views/main/oerationLog/index'),
            meta: {
              title: '财务中台-操作审计日志',
              keepAlive: true // 需要缓存
            },
          },

          {
            path: 'clientManage',
            name: 'clientManage',
            component: () => import('@/views/main/clientManage/index'),
            meta: {
              title: '财务中台-客户管理',
              keepAlive: true // 需要缓存
            },
          },
        ]
    },

    {
      path: '/accidentRiskDetail',
      name: 'accidentRiskDetail',
      component: () => import('@/views/main/accidentRisk/settlementProjectDetail'),
      meta: {
        title: '财务中台-意健险-结算立项'
      },
    },

    {
      path: '/carInsuranceDetail',
      name: 'carInsuranceDetail',
      component: () => import('@/views/main/carInsurance/settlementProjectDetail'),
      meta: {
        title: '财务中台-意健险-结算立项'
      },
    },

    {
      path: '/carOutsourceDetail',
      name: 'carOutsourceDetail',
      component: () => import('@/views/main/carOutsource/settlementProjectDetail'),
      meta: {
        title: '财务中台-意健险-结算立项'
      },
    },


    {
      path: '/assetsAppraisalDetail',
      name: 'assetsAppraisalDetail',
      component: () => import('@/views/main/assetsAppraisal/settlementProjectDetail'),
      meta: {
        title: '财务中台-意健险-结算立项'
      },
    },

    {
      path: '/claimsDetail',
      name: 'claimsDetail',
      component: () => import('@/views/main/claims/claimsSettlementProjectDetail'),
      meta: {
        title: '财务中台-意健险-结算立项'
      },
    },

    {
      path: '/compensateDetail',
      name: 'compensateDetail',
      component: () => import('@/views/main/compensate/settlementProjectDetail'),
      meta: {
        title: '财务中台-意健险-结算立项'
      },
    },

    {
      path: '/medicalInsuranceDetail',
      name: 'medicalInsuranceDetail',
      component: () => import('@/views/main/medicalInsurance/settlementProjectDetail'),
      meta: {
        title: '财务中台-意健险-结算立项'
      },
    },

]